import { gql } from '@apollo/client';

export interface ReferenceFlavorLexiconResponse {
  allReferenceFlavorNews: {
    nodes: { name: string; deleted: boolean | null }[];
  };
}

/** Every visible reference flavor reviewers can pick, for the optimization flavor pool. */
export default gql`
  query ReferenceFlavorLexiconQuery {
    allReferenceFlavorNews(condition: { visible: true }) {
      nodes {
        name
        deleted
      }
    }
  }
`;
